import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Employees from 'employees/components';
import EmployeesListHandlers from 'employees/containers/EmployeesListHandlers';
import EmployeesRowContainer from 'employees/containers/EmployeesRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleEmployees,
  getIsLoading,
  getNeedFetch,
} from 'employees/selectors';

////////
import { toggle } from 'employees/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';
////////

class EmployeesListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };
  ////////////////////
  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  ////////////////////

  render = () => (
    <EmployeesListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
        handleExport,
      }) => (
        <Employees.ListView
          count={this.props.employees.length}
          filters={this.props.filters}
          handleExport={handleExport}
          company={this.props.company}
          isLoading={this.props.isLoading}
          ////////////////////////
          handleToggle={this.handleToggle}
          ////////////////////////
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.employees.map((employee) => (
            <EmployeesRowContainer
              key={employee.id}
              employee={employee}
              ////////
              handleToggle={this.handleToggle}
              ////////
            />
          ))}
        </Employees.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  employees: getVisibleEmployees(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
////////////
const mapDispatchToProps = { toggle, error, success };
////////////

export default connect(
  mapStateToProps,
  ////////////
  mapDispatchToProps
  ////////////
)(EmployeesListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/EmployeesListContainer.js